import { WsSelect } from 'wisestep-base';

export enum IDuration {
  SEVEN_DAYS = '7 Days - Daily',
  THIRTY_DAYS = '30 days - Weekly',
  EIGHT_WEEKS = '8 Weeks - Weekly',
}

export interface IDurationDropDown {
  defaultValueKey: string;
}

const DurationDropDown = ({ defaultValueKey }: IDurationDropDown) => {
  const options = Object.values(IDuration).map((value) => ({
    label: value,
    value: value,
  }));

  return <WsSelect name="duration" selectArray={options} defaultValue={defaultValueKey} />;
};

export default DurationDropDown;
